import { useEffect, useRef } from 'react';
import { useStore } from 'effector-react';
import { makeStyles } from '@mui/styles';
import { $userRole, fxGetRoleData } from '@features/common';
import { BmsName } from '../components/bmsName';
import { setScreenY } from '../models';
import NavItem from './navItem';

const useStyles = makeStyles({
  navList: {
    display: 'grid',
    alignContent: 'start',
    backgroundColor: 'white',
    heigth: '100%',
    zIndex: 2,
    // --- скрываем скролл ---
    overflow: 'auto',
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  // ---
});

function NavList(props) {
  const { items = [], isCollapsed, screenY } = props;
  const refNavList = useRef(null);
  const classes = useStyles();
  const userRole = useStore($userRole);

  useEffect(() => {
    if (!isCollapsed) {
      if (refNavList.current !== null) {
        refNavList.current.scrollTo(0, screenY);
      }
    }
    return () => {
      if (!isCollapsed) {
        setScreenY(refNavList.current.scrollTop);
        refNavList.current.scrollTo(0, 0);
      }
    };
  }, [isCollapsed]);

  useEffect(() => {
    fxGetRoleData({ role_id: userRole.id });
  }, [userRole.id]);

  return (
    <>
      <BmsName name={userRole.bms_type?.title} />

      <nav className={classes.navList} ref={refNavList}>
        {items.map((item) => (
          <NavItem {...item} key={`i-${item?.text}`} />
        ))}
      </nav>
    </>
  );
}

export default NavList;
